import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { get } from '../Storage';
import CircularProgress from 'material-ui/CircularProgress';
import { Message } from "mgUiKit";
import { Card, CardHeader, CardText } from 'material-ui/Card';
import WithdrawalTools from '../Page/WithdrawalTools';
import { SwitchTheme } from "mgUiKit";
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'AssistenzaComponent';

var styles = AppSettings.styles;

class Assistenza extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            opened: false,
        }

        this.loadAssistenza = this.loadAssistenza.bind(this);
        this.socialContainerRef = React.createRef();
     
    }

    loadAssistenza() {

        if (this.state.opened) {
            this.setState({
                opened: false
            });
        }
        else {

            this.setState({
                opened: true
            });
        }
    }

   
    renderAssistenza() {

        const renderedElements = [];
        for (let item of this.state.data.items) {
            if (item.active) {
                //link - text - javascript
                let classtype = 'mg-cta-site mg-btn-site mg-user-widget--' + item.classname;
                if(item.type == "link")
                {
                    renderedElements.push(<a className={classtype} key={item.id} title={item.title} target={item.target ? item.target : ""} href={item.link}>{item.value}</a>);
                }
                else if(item.type == "text")
                {
                    renderedElements.push(<p className={'mg-user-widget--' + item.classname} key={item.id}>{item.description}</p>);
                }
                else if(item.type == "javascript")
                {
                    renderedElements.push(<a className={classtype} key={item.id} title={item.title} href={item.link}>{item.value}</a>);
                }     
            }           
        }

        

        return (
            <>
                <div className='mg-assistenza-wrap ub-buttons-wrap'>
                    {renderedElements}
                </div>

            </>

        );
        // } 
    }


    render() {
        var title = <div style={styles.pointer} onClick={this.loadAssistenza}>{this.state.data.title}</div>;

        return (
            <div id="mg-assistenza" className="mg-user-widget">

                <Card containerStyle={styles.mgCardStyle} className="mg-assistenza" expanded={this.state.opened} onExpandChange={this.loadAssistenza}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                        subtitleStyle={styles.mgCardSubTitle}
                        title={title}
                        subtitle={this.state.data.subtitle}
                        actAsExpander={false}
                        showExpandableButton={true}
                        avatar={<i className="fa-mg fa-mg-livechat-2 mg-user-icon"></i>}

                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.renderAssistenza()}
                    </CardText>
                </Card>
            </div>

        );
    }
}
Assistenza.displayName = componentName;

// PropTypes validation
Assistenza.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
Assistenza.defaultProps = {
    data: {}
};


Assistenza.contextTypes = {

}
export default Assistenza;